<template>
    <div>
<!--        整体高度52px-->
        <div v-if="$common.isClient_whole()" style="padding-top: 0px"></div>
        <div>
            <div style="padding: 5px">
                <div v-if="round" style="padding: 2px 0px;">
                    <van-search class="van_search" ref="van_search" background="rgba(255,255,255,0)" :style="{padding: '0px', borderRadius: '25px'}"
                                v-model="search_value"
                                :show-action="showPop"
                                shape="round"
                                placeholder="请输入搜索关键词"
                                @search="clickToSearch"
                                @click.stop="searchInputClick('0')"
                                @input="inputListener"
                    >
                        <template #action>
                            <div @click="clickCloseIcon">取消</div>
                        </template>
                        <div slot="right-icon" style="margin-left: 5px; margin-right: 5px" @click.stop="clickToSearch">
                            <span :style="{color: common_transparent ? bgColor : '#EE0A24'}">搜索</span>
                        </div>
                    </van-search>
                </div>

                <div v-else style="display: flex;">
                    <van-field
                            style="padding: 0px; background-color: rgba(255,255,255,0); "
                    >
                        <div class="search_input_out" slot="input"
                             :style="{borderColor: common_transparent ? fontColor : '#ee0a24'}">
                            <van-field ref="search_field"
                                       style="padding: 0px; background-color: rgba(0,0,0,0)"
                                       v-model="search_value"
                                       placeholder="请输入搜索关键词"
                                       clearable
                                       @click="searchInputClick('0')"
                                       @input="inputListener"
                            >
                                <div slot="left-icon" style="width: 10px"></div>
                                <div slot="button" style="height: 40px; background-color: orange;"></div>
                            </van-field>
                        </div>

                        <van-field
                                slot="button"
                                style="padding: 0px; border-radius:0px 5px 5px 0px">
                            <div slot="input" style="width: 0px"></div>
                            <div slot="button">
                                <van-button class="search_button" slot="button" type="danger" icon="search" :color="common_transparent ? bgColor : '#ee0a24'"
                                            :style="{borderColor: common_transparent ? fontColor: ''}"
                                            v-on:click="clickToSearch"
                                >搜索
                                </van-button>

                            </div>

                        </van-field>
                    </van-field>
                    <div v-if="showPop" style="width: 50px; height: 42px; line-height: 42px; text-align: center; font-size: 14px" @click="clickCloseIcon">
                        取消
                    </div>
                </div>

            </div>


            <div :class="history_box_div" id="history_whole_div_id" :style="{maxHeight: showPop ? (getScreenHeight() - 50) + 'px' : '0px', paddingBottom: showPop ? '50px' : '0px'}">

                <div>

<!--                <div :style="{maxHeight: showPop ? ($common.screenHeight - 50) + 'px' : '0px'}">-->

                    <van-divider style="margin-top: 0px; margin-bottom: 0px; border-color: #dddddd"/>
                    <div :style="{minHeight: (getScreenHeight() - 50) + 'px', width: $common.screenWidth + 'px'}">

                        <div style="padding: 5px 10px">
                            <div v-if="search_value_list && search_value_list.length > 0" style="margin-bottom: 10px">
                                <div style="display: flex; padding: 10px 5px 5px 5px">
                                    <span style="flex: 2; text-align: left; font-size: 16px">搜索历史</span>
                                    <van-icon name="delete" size="22" color="#777777" @click="clickToClearHistory"
                                              style="flex: 1; text-align: right; margin-top: 2px; margin-left: 15px"
                                    />
                                </div>
                                <div>
                                    <span v-for="(search_tag, index) in search_value_list" :key="index">
                                        <van-tag v-if="index < show_tag_limit" round size="large" color="#f5f5f5" text-color="#666666" @click="clickTag(search_tag)" style="margin: 5px; padding: 4px 15px">
                                            <div slot="default" style="; text-align: center">
                                                <span v-if="search_tag.length > 6">
                                                    {{search_tag.substring(0,6) + "..."}}
                                                </span>
                                                <span v-else>
                                                    {{search_tag}}
                                                </span>
                                            </div>
                                        </van-tag>
                                    </span>
                                    <van-tag v-if="search_value_list && search_value_list.length > limit_tag_base" round plain size="large" type="danger" style="margin: 5px; padding: 4px 15px" @click="showAndHide">{{show_hide_text}}</van-tag>
                                </div>
                            </div>

                            <div v-if="hot_words_list && hot_words_list.length > 0">
                                <div style="display: flex; padding: 10px 5px 5px 5px">
                                    <span style="flex: 2; text-align: left; font-size: 16px">搜索热词</span>
                                </div>
                                <div>
                                <span v-for="(hot_word_tag, index) in hot_words_list" :key="index">
                                    <van-tag round size="large" color="#f5f5f5" text-color="#666666" @click="clickTag(hot_word_tag)" style="margin: 5px; padding: 4px 15px">
                                        <div slot="default" style="; text-align: center">
                                            <span v-if="hot_word_tag.length > 6">
                                                {{hot_word_tag.substring(0,6) + "..."}}
                                            </span>
                                            <span v-else>
                                                {{hot_word_tag}}
                                            </span>
                                        </div>
                                    </van-tag>
                                </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
<!--        <div style="padding: 5px">-->
<!--            <van-field-->
<!--                    style="padding: 0px; background-color: rgba(255,255,255,0); "-->
<!--            >-->
<!--                <div class="search_input_out" slot="input"-->
<!--                     :style="{borderColor: common_transparent ? fontColor : '#ee0a24'}">-->
<!--                    <van-field ref="search_field"-->
<!--                               style="padding: 0px; background-color: rgba(0,0,0,0)"-->
<!--                               v-model="search_value"-->
<!--                               placeholder="请输入搜索关键词"-->
<!--                               clearable-->
<!--                               @click="searchInputClick('0')"-->
<!--                               @input="inputListener"-->
<!--                    >-->
<!--                        <div slot="left-icon" style="width: 10px"></div>-->
<!--                        <div slot="button" style="height: 40px; background-color: orange;"></div>-->
<!--                    </van-field>-->
<!--                </div>-->

<!--                <van-field-->
<!--                        slot="button"-->
<!--                        style="padding: 0px; border-radius:0px 5px 5px 0px">-->
<!--                    <div slot="input" style="width: 0px"></div>-->
<!--                    <div slot="button">-->
<!--                        <van-button class="search_button" slot="button" type="danger" icon="search" :color="common_transparent ? bgColor : '#ee0a24'"-->
<!--                                    :style="{borderColor: common_transparent ? fontColor: ''}"-->
<!--                                    v-on:click="clickToSearch"-->
<!--                        >搜索-->
<!--                        </van-button>-->

<!--                    </div>-->

<!--                </van-field>-->
<!--            </van-field>-->

<!--        </div>-->

<!--        <van-popup-->
<!--                v-model="showPop"-->
<!--                position="center"-->
<!--                :overlay="false"-->
<!--                :style="{marginTop: margin_top}"-->
<!--        >-->
<!--            <div>-->
<!--                <div style="text-align: center; padding: 10px 0px">-->
<!--                    <van-icon name="delete" size="22" color="#777777" @click="clickToClearHistory"-->
<!--                              style="position: absolute; left: 15px; margin-top: 2px"-->
<!--                    />-->
<!--                    <span style="font-size: 16px">搜索历史</span>-->
<!--                    <van-icon name="close" size="22" color="#EE0A24" @click="clickCloseIcon"-->
<!--                              style="position: absolute; right: 15px; margin-top: 2px"-->
<!--                    />-->
<!--                </div>-->
<!--                <van-divider style="margin-top: 0px; margin-bottom: 0px; border-color: #dddddd"/>-->
<!--                <div :style="{height: ($common.screenHeight - 50) + 'px', width: $common.screenWidth + 'px'}">-->
<!--&lt;!&ndash;                    <van-grid :column-num="4" :border="false" style="padding: 10px 10px">&ndash;&gt;-->
<!--&lt;!&ndash;                        <van-grid-item&ndash;&gt;-->
<!--&lt;!&ndash;                                v-for="(search_tag, index) in search_value_list"&ndash;&gt;-->
<!--&lt;!&ndash;                                :key="index"&ndash;&gt;-->
<!--&lt;!&ndash;                        >&ndash;&gt;-->
<!--&lt;!&ndash;                            <van-tag size="medium" @click="clickTag(search_tag)">&ndash;&gt;-->
<!--&lt;!&ndash;                                <div slot="default" style="width: 60px; text-align: center">&ndash;&gt;-->
<!--&lt;!&ndash;                                    {{search_tag}}&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--&lt;!&ndash;                            </van-tag>&ndash;&gt;-->
<!--&lt;!&ndash;                        </van-grid-item>&ndash;&gt;-->
<!--&lt;!&ndash;                    </van-grid>&ndash;&gt;-->
<!--                    <div style="padding: 5px 10px">-->
<!--                        <span v-for="(search_tag, index) in search_value_list" :key="index"-->

<!--                        >-->
<!--                            <van-tag size="large" @click="clickTag(search_tag)" style="margin: 5px">-->
<!--                                <div slot="default" style="; text-align: center">-->
<!--                                    <span v-if="search_tag.length > 6">-->
<!--                                        {{search_tag.substring(0,6) + "..."}}-->
<!--                                    </span>-->
<!--                                    <span v-else>-->
<!--                                        {{search_tag}}-->
<!--                                    </span>-->
<!--                                </div>-->
<!--                            </van-tag>-->
<!--                        </span>-->
<!--                    </div>-->

<!--                </div>-->

<!--            </div>-->
<!--        </van-popup>-->
    </div>

</template>

<script>
    import {Toast} from 'vant';
    export default {
        name: "Wp_search_model",
        props:{
            searchValue: {type: String, default: ""},
            bgColor: {type: String, default: ""},
            fontColor: {type: String, default: ""},
            defaultClickSearch: {type: Boolean, default: false},
            commonTransparent : {type: Boolean, default: false},
            showHistory: {type: Boolean, default: false},
            offsetTop:{type: Number, default: 0},
            round: {type: Boolean, default: true}
        },

        data(){
            return{
                search_value: "",
                showPop: false,
                pop_height: this.$common.screenHeight - 50,
                search_value_list: [],
                common_transparent: false,
                focus: false,
                margin_top: '50px',
                history_box_div: 'history_box_div_hide',

                limit_tag_base: 10,//显示标签数的基础值
                show_tag_limit: 0,

                show_hide_text: '展开',

                hot_words_list: [],

                test_list: [],
            }
        },

        created() {
            this.search_value_list = this.$store.state.search_value_datas;
            // this.$common.transparent = true;
            if(this.showHistory){
                this.showHistoryPop();
            }
            if(this.$common.isClient_whole()){
                this.margin_top = (100 + this.offsetTop) + 'px';
            }else{
                this.margin_top = (50 + this.offsetTop) + 'px';
            }

            this.show_tag_limit = this.limit_tag_base;

            this.initHotWords();

            // for(let i = 0; i < this.search_value_list.length * 100; i++){
            //     this.test_list.push(this.search_value_list[0]);
            // }
        },

        mounted() {
            // this.$refs.search_field.focus();
            // common_transparent ? fontColor : '#ee0a24'

            this.initVanSearchBorderColor();
        },

        watch:{
            searchValue(newValue){
                this.$log("--------searchValue---------" + newValue)
                this.search_value = newValue;
            },
            defaultClickSearch(newValue){
                if(newValue){
                    // this.focus = true;
                    this.$refs.search_field.focus();
                    this.searchInputClick("0");
                }
            },
            commonTransparent(newValue){
                this.common_transparent = newValue;
                this.initVanSearchBorderColor();
            },

            fontColor(newColor){
                this.initVanSearchBorderColor();
            }
        },

        methods:{

            getScreenHeight(){
                return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
            },

            /**
             * 初始化van-search中内部输入框的样式中的border-color的值，
             * 因要动态修改van-search的默认样式名的样式内容，所以只能通过这种方式修改
             */
            initVanSearchBorderColor(){
                // this.$log(this.$refs.van_search)
                // this.$log("this.common_transparent = " + this.common_transparent)
                // this.$log("this.fontColor = " + this.fontColor)
                if(this.$refs.van_search){
                    if(this.common_transparent){
                        this.$refs.van_search.style.setProperty("--borderColor", this.fontColor);
                    }else{
                        this.$refs.van_search.style.setProperty("--borderColor", '#ee0a24');
                    }
                }
            },

            initHotWords(){
                let hot_words = this.$store.state.jd_hot_words;
                hot_words = hot_words.replace(new RegExp(' ','g'), '');
                this.hot_words_list = hot_words.split(',');
            },

            showAndHide(){
                if(this.show_tag_limit === this.limit_tag_base){
                    this.show_tag_limit = 100;
                    this.show_hide_text = '收起';
                }else{
                    this.show_tag_limit = this.limit_tag_base;
                    this.show_hide_text = '展开';
                }
            },

            getContainer(){
                return document.querySelector('.pop_container');
            },
            /**
             * 清空搜索历史
             */
            clickToClearHistory(){
                this.search_value_list = [];
                this.search_value = "";
                this.$store.commit('setSearchValues', this.search_value_list);
                // this.clickCloseIcon();
                this.clickToSearch();
            },
            /**
             * 点击搜索历史中的一个关键字
             * @param searchTag
             */
            clickTag(searchTag){
                this.search_value = searchTag;
                this.inputListener(searchTag);
                this.clickToSearch();
            },

            showHistoryPop(){
                if((this.search_value_list && this.search_value_list.length > 0) || (this.hot_words_list && this.hot_words_list.length > 0)){
                    this.showPop = true;
                    this.history_box_div = 'history_box_div_show';
                    this.$emit("onSearchShowHistory", true);

                    // setTimeout(()=>{
                    //     // this.$nextTick(()=>{
                    //     //     this.$refs.history_whole_div.scrollTo(0, 100);
                    //     // })
                    //     document.getElementById("history_whole_div_id").scrollIntoView()
                    // }, 50)
                    //保证每次打开历史搜索界面时滚动条位于顶部
                    document.getElementById('history_whole_div_id').scrollTop = 0;
                }
            },
            searchInputClick(id){
                this.showHistoryPop();

                this.$emit("searchInputClick", id);
            },

            inputListener(value){
                this.$emit('inputListener', value)
            },

            clickToSearch(){
                this.clickCloseIcon();
                setTimeout(()=>{
                    if(this.search_value_list && this.search_value){
                        if(!this.search_value_list.includes(this.search_value)){
                            if(this.search_value_list.length >= 100){
                                //超过30个数据，则删除最后一个
                                this.search_value_list.pop();
                            }
                            // this.search_value_list.splice(19, this.search_value_list.length -19)
                            //将最新的搜索关键字添加到缓存数组的第一位
                            this.search_value_list.unshift(this.search_value);
                            this.$store.commit('setSearchValues', this.search_value_list);
                        }else{
                            //如果搜索的关键字包含在缓存的数组中
                            if(this.search_value_list.indexOf(this.search_value) > 0){
                                // this.$log(this.search_value_list.indexOf(this.search_value))
                                this.search_value_list.splice(this.search_value_list.indexOf(this.search_value), 1);

                                //将最新的搜索关键字添加到缓存数组的第一位
                                this.search_value_list.unshift(this.search_value);
                                this.$store.commit('setSearchValues', this.search_value_list);
                            }
                        }

                    }
                }, 500);

                this.getSearchValue();
                this.$emit("clickToSearch");

                //
                // Dialog.alert({
                //     message: 'height = ' + window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
                // })
            },

            getSearchValue(){
                this.$emit("getSearchValue", this.search_value);
            },

            clickCloseIcon(){
                this.showPop = false;
                this.history_box_div = 'history_box_div_hide';
                setTimeout(()=>{
                    this.show_tag_limit = this.limit_tag_base;
                    this.show_hide_text = '展开';
                }, 500);

                this.$emit("onSearchShowHistory", false);

            }
        }
    }
</script>

<style >

    .search_input_out{
        margin-right: -10px;
        border-radius:5px 0px 0px 5px;
        border: 1px solid;
        background-color: white;
    }
    .search_button{
        display: flex;
        height: 42px;
        line-height: 1;
        border-radius: 0px 5px 5px 0px;
        margin-left: -10px
    }

    .history_whole_div{
        background-color: white;
        z-index: 2001;
        position: absolute;
        left: 0px;
        right: 0px;
        overflow: auto;
    }

    .history_box_div_hide {
        /*position:relative;*/
        max-height: 0px;
        -webkit-transition: max-height 0.2s;
        transition: max-height 0.2s;
        overflow: hidden;

        background-color: white;
        z-index: 2001;
        position: absolute;
        left: 0px;
        right: 0px;
        /*overflow: auto;*/
    }

    .history_box_div_show {
        /*overflow: hidden;*/
        -webkit-transition: max-height 0.3s;
        transition: max-height 0.3s;
        /*max-height: 100px;*/

        background-color: white;
        z-index: 2001;
        position: absolute;
        left: 0px;
        right: 0px;
        overflow: auto;
    }

    .van_search{
        /*--borderColor: #ee0a24;*/
        --borderColor: #ffffff;
    }
    .van-search__content{
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        flex: 1;
        padding-left: 8px;
        background-color: #ffffff;
        border-radius: 25px;
        border: 1px solid;
        border-color: var(--borderColor)
    }
</style>